import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import styles from 'styles/css/Main.module.scss';
import drawerStyles from 'styles/css/Drawer.module.scss';
import actionStyles from 'styles/css/ActionStyles.module.scss';
import Logo from 'styles/images/logo/logo512.png';
import LogoWhite512 from 'styles/images/logo/logo512-white.png';
import LogoBlack512 from 'styles/images/logo/logo512-black.png';
import Instagram from 'styles/images/svg/instagram.svg';
import LinkedIn from 'styles/images/svg/linkedin.svg';
import YouTube from 'styles/images/svg/youtube.svg';
import Facebook from 'styles/images/svg/facebook.svg';
import ForwardIcon from 'styles/images/svg/forward-white.svg';
import ArrowUp from 'styles/images/svg/arrow-up.svg';
import ArrowDown from 'styles/images/svg/arrow-down.svg';
import { API_MAIN, USERS_LOGOUT_GET } from 'apis';
import apiRequest from 'utils/apiRequest';
import { handleChangeDataPageMain } from 'reduxx/actions/pages/main';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import Swal from 'sweetalert2';
import { useTranslation } from "react-i18next";
import { useLocalePath } from 'utils/useLocalePath';

const Main = () => {

    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const to = useLocalePath();

    const { lng } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mainSlider, adsSlider, features, projects, articles } = useSelector(state => state.main);
    const { isMobile } = useSelector(state => state.general);

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        // const onScroll = () => setScrolled(window.scrollY > 8); // آستانه تغییر حالت هدر
        // window.addEventListener('scroll', onScroll, { passive: true });
        // onScroll();
        // return () => window.removeEventListener('scroll', onScroll);
        setScrolled(true);
    }, []);

    useEffect(() => {
        i18n.changeLanguage(lng);
        apiMain();
    }, [Main, lng]);

    const apiMain = () => {
        apiRequest({
            dispatch,
            endpoint: API_MAIN,
            method: 'post',
            data: {width: window.innerWidth},
            successMessage: null,
            onSuccess: (res) => {
                dispatch(handleChangeDataPageMain('mainSlider', res.mainSlider));
                dispatch(handleChangeDataPageMain('adsSlider', res.adsSlider));
                dispatch(handleChangeDataPageMain('features', res.features));
                dispatch(handleChangeDataPageMain('projects', res.projects));
                dispatch(handleChangeDataPageMain('articles', res.articles));
            }
        });
    };



    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const toggleAbout = () => setIsAboutOpen((prev) => !prev);

    const drawerRef = useRef(null);
    const touchStartX = useRef(null);
    const touchCurrentX = useRef(null);

    // بستن Drawer با کلیک خارج
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDrawerOpen && drawerRef.current && !drawerRef.current.contains(event.target)) {
                setIsDrawerOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isDrawerOpen]);

    useEffect(() => {
        if (isDrawerOpen) {
            document.body.style.overflow = "hidden"; // قفل کردن اسکرول
        } else {
            document.body.style.overflow = "auto"; // آزاد کردن اسکرول
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isDrawerOpen]);


    // مدیریت رویدادهای لمسی برای کشیدن
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchCurrentX.current = touchStartX.current;
    };

    const handleTouchMove = (e) => {
        touchCurrentX.current = e.touches[0].clientX;
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 0 && drawerRef.current) {
            drawerRef.current.style.transform = `translateX(${Math.max(0, deltaX)}px)`;
        }
    };

    const handleTouchEnd = () => {
        const deltaX = touchCurrentX.current - touchStartX.current;
        if (deltaX > 50) { // اگه بیشتر از 50px به چپ کشیده شد، Drawer بسته بشه
            setIsDrawerOpen(false);
        }
        if (drawerRef.current) {
            drawerRef.current.style.transform = ''; // بازگرداندن به حالت پیش‌فرض
        }
        touchStartX.current = null;
        touchCurrentX.current = null;
    };

    

    const project_swiper = {
        slidesPerView: 5,
        spaceBetween: 20,
        direction:'horizontal',
        className:"mySwiper",
        // nested: true,
        breakpoints: {
            0: {
                slidesPerView: 1.25,
            },
            1024: {
                slidesPerView: 3.8,
            }
        }
    }


    return (
        
        <div className={[sharedStyles.container, scrolled ? sharedStyles.scrolled : ''].join(' ')}>
            <header className={[styles.header, scrolled ? styles['header--sticky'] : ''].join(' ')} style={{direction: 'rtl'}}>
            {/*<header className={[styles.header, styles['header--sticky']].join(' ')}>*/}
            	<div className={[sharedStyles.flex, sharedStyles['gap-md'], sharedStyles.itemsCenter].join(' ')}>
            		{ isMobile &&
                        <button className={styles['menu-btn']} aria-label="menu" onClick={toggleDrawer}>
    	                    <span />
    	                    <span />
    	                    <span />
    	                </button>
                    }
	                {/*<Link to={`/en`} className={[styles['lang-btn'], lng === "en" ? styles['active'] : ""].join(' ')}>En</Link>
	                <Link to={`/fa`} className={[styles['lang-btn'], lng === "fa" ? styles['active'] : ""].join(' ')}>Fa</Link>*/}
            	</div>

                { ! isMobile &&
                    <div className={styles["desktop-menu"]} style={{display: "flex", gap: "25px"}} dir={i18n.dir()}>
                        <Link to={to(`/`)}>{t("menu_home")}</Link>
                        <Link to={to(`/products`)}>{t("menu_products")}</Link>
                        <Link to={to(`/about-us`)}>{t("menu_about_us")}</Link>
                        <Link to={to(`/contact-us`)}>{t("menu_contact_us")}</Link>
                        <Link to={to(`/consultation`)} >{t("menu_consultation")}</Link>
                    </div>
                }
	                
                <div className={styles.logo}>
                    <img src={scrolled ? LogoBlack512 : LogoWhite512} alt="logo" />
                </div>
            </header>

            <section className={styles.hero} >
                <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={0}
                    slidesPerView={1}
                    // pagination={{ clickable: true }}
                    // navigation={true}
                    pagination={false}
                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                    className={styles.swiper}
                >
                    {mainSlider.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className={styles.slide} style={{ backgroundImage: `url(${slide.image})` }}></div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <Link to={to(`/consultation`)} className={[styles['cta-btn'], sharedStyles.decorationNone].join(' ')}>{t("consult_req")}</Link>
                {/*<br />
                <button onClick={() => navigate(`/surgury-consultation`)} className={styles['cta-btn']}>درخواست مشاوره اعمال جراحی</button>*/}
            </section>

            {isDrawerOpen && (
                <div className={drawerStyles.overlay} onClick={toggleDrawer}></div>
            )}
            <div 
                    ref={drawerRef} 
                    onTouchStart={handleTouchStart} 
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                    className={`${drawerStyles.drawer} ${isDrawerOpen ? drawerStyles['drawer--open'] : ''}`}>
                <div className={drawerStyles.header}>
                    <img src={LogoBlack512} height={60} alt="دکتر20" />

                    <button className={drawerStyles['close-btn']} onClick={toggleDrawer}>
                        ✕
                    </button>
                </div>
                    
                <nav className={drawerStyles['drawer-nav']}>
                    <ul className={sharedStyles['pb-[32px]']}>
                        <li><Link to={to(`/`)}>{t("menu_home")}</Link></li>
                        <li><Link to={to(`/categories`)}>{t("menu_products")}</Link></li>
                        <li><Link to={to(`/about-us`)}>{t("menu_about_us")}</Link></li>
                        <li><Link to={to(`/contact-us`)}>{t("menu_contact_us")}</Link></li>

                        <Link to={to(`/consultation`)} style={{textDecoration: "none", backgroundColor: "var(--primary-color)", color: "#fff", border: "none", borderRadius: "36px", justifyContent: "center", marginTop: "12px"}}>{t("consult_req")}</Link>

                    </ul>
                </nav>
            </div>



            <section className={[styles.intro, sharedStyles['container-padding']].join(' ')}>
                <h1>
                    {t("main_page_title_1")}
                    <br />
                    {t("main_page_title_2")}
                    <br />
                    {t("main_page_title_3")}
                </h1>
            </section>

            <section className={[styles['content-card'], sharedStyles['container-padding'], sharedStyles.flex, sharedStyles.flexWrap, sharedStyles['gap-md']].join(' ')}>
                {
                    adsSlider.map((ads, key) => (
                    	<Link to={to(`/category/${ads.id}`)} className={[styles['card-inner'], sharedStyles['text-primary'], sharedStyles.decorationNone].join(' ')}>
                            <div className={styles['placeholder-img']}>
                                <img src={ads.image} alt={ads.title} />
                            </div>
                            <div className={styles.note}>
                                <span className={sharedStyles['card-text']}>{ads.title}</span>
                                <div className={styles['back-btn']}>
                                    <img src={ForwardIcon} width={20} />
                                </div>
                            </div>
                        </Link>
                    ))
                }
                
            </section>

            <section className={[styles.features, sharedStyles['container-padding']].join(' ')}>
                <div className={[sharedStyles.flex, sharedStyles.flexWrap, sharedStyles['gap-md']].join(' ')}>
                    {
                        features.map((feature, key) => (
                            <div key={`features-${key}`} className={styles.featureBox}>
                                <img src={feature.image} alt={feature.title} />
                                <span>{feature.title}</span>
                            </div>
                        ))
                    }
                </div>

                <p className={[sharedStyles['w-full'], sharedStyles['text-center']].join(' ')}>
                    <button onClick={() => navigate(to(`/consultation`))} className={[styles['cta-full'], styles['mt-24']].join(' ')}>{t("consult_req")}</button>
                </p>
                
            </section>



            <footer className={styles.footer}>
                <div className={styles.socials}>
                    <a href="https://instagram.com/arzyab.machine.fars"><img src={Instagram} width={32} /></a>
                    <a href="#"><img src={LinkedIn} width={32} /></a>
                    <a href="#"><img src={YouTube} width={32} /></a>
                    <a href="#"><img src={Facebook} width={32} /></a>
                </div>

                <div className={styles['contact-us']}>
                    {t("office_address")}:
                    <br />
                    {t("office_address_val")}
                </div>

                <div className={styles['contact-us']}>
                    {t("concat_numbers")}:
                    <br />
                    <a href={`tel:${t("concat_number_1_href")}`} style={{textDecoration: "none", color: "unset"}} dir={i18n.dir() === "rtl" ? "ltr" : ""}>{t("concat_number_1")}</a>
                    <br />
                    <a href={`tel:${t("concat_number_2_href")}`} style={{textDecoration: "none", color: "unset"}} dir={i18n.dir() === "rtl" ? "ltr" : ""}>{t("concat_number_2")}</a>
                    <br />
                    <a href={`tel:${t("concat_number_3_href")}`} style={{textDecoration: "none", color: "unset"}} dir={i18n.dir() === "rtl" ? "ltr" : ""}>{t("concat_number_3")}</a>
                </div>

                <div className={styles['contact-us']}>
                    {t("working_hours")}:
                    <br />
                    {t("working_hours_val_1")}
                    <br />
                    {t("working_hours_val_2")}
                </div>


            </footer>
        </div>

    );
}

export default Main;